import { useGetFrontCompetenzeRicercabili } from '@framework/api-client/api/inquiries-compile/competenze-ricercabili-controller/competenze-ricercabili-controller.ts';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface IInquiryCompetenceSelectInputProps {
  name: string;
}

/**
 * Select input per la competenza territoriale
 */
export function InquiryCompetenceSelectInput(
  props: IInquiryCompetenceSelectInputProps,
) {
  const { name } = props;
  const { t } = useTranslation();
  const { data: competences, isLoading } = useGetFrontCompetenzeRicercabili({
    query: { keepPreviousData: true },
  });

  const options = useMemo(() => {
    return competences?.map(competence => ({
      value: competence.idCompetenza!,
      label: competence.denominazione,
    }));
  }, [competences]);

  return (
    <SelectInput
      allowClear
      mode="multiple"
      optionFilterProp="label"
      showSearch
      style={{ width: '100%' }}
      loading={isLoading}
      name={name}
      placeholder={t(
        'inquiry.competenza-territoriale',
        'Competenza Territoriale',
      )}
      options={options}
    />
  );
}
